const search = document.getElementById('mobileSearch');
const searchOpen = document.getElementById('mobileSearchOpen');
const searchClose = document.getElementById('mobileSearchClose');
const searchInput = document.getElementById('mobileSearchInput');

const menu = document.getElementById('menu');
const menuOpen = document.getElementById('menuOpen');
const menuClose = document.getElementById('menuClose');

const body = document.body;

function openSearch() {
  search.classList.add('is-open');
  body.classList.add('is-open');
  mobileSearchInput.focus();
}

function closeSearch() {
  search.classList.remove('is-open');
  body.classList.remove('is-open');
}

function openMenu() {
  menu.classList.add('is-open');
  body.classList.add('is-open');
}

function closeMenu() {
  menu.classList.remove('is-open');
  body.classList.remove('is-open');

  document.querySelectorAll('.menu-item.is-open').forEach(item => {
    item.classList.remove('is-open');
  });
}

searchOpen.addEventListener('click', openSearch);
searchClose.addEventListener('click', closeSearch);
menuOpen.addEventListener('click', openMenu);
menuClose.addEventListener('click', closeMenu);

document.addEventListener("click", function (event) {
  // Handle opening
  const openBtn = event.target.closest(".menu-button");
  if (openBtn) {
    const menuItem = openBtn.closest(".menu-item");
    if (menuItem) {
      menuItem.classList.add("is-open");
    }
    return; // Stop here so it doesn't also match the close trigger
  }

  // Handle closing
  const closeBtn = event.target.closest(".header-button--back");
  if (closeBtn) {
    const menuItem = closeBtn.closest(".menu-item");
    if (menuItem) {
      menuItem.classList.remove("is-open");
    }
  }
});

